import { useTranslation } from 'react-i18next';

import useAiChatToolLabel from '../../hooks/useAiChatToolLabel';
import useAiChatToolStatus from '../../hooks/useAiChatToolStatus';
import AiChatToolCard from '../AiChatToolCard';

import type { ReactElement } from 'react';
import type { IAiChatToolCallOf } from '../../interfaces/IAiChatToolCall';

/** The `searchWatchCompanies` tool call: registry hits for New company seeds. */
function SearchWatchCompaniesToolCall({
  part,
}: IAiChatToolCallOf<'searchWatchCompanies'>): ReactElement {
  const { t } = useTranslation();
  const label = useAiChatToolLabel('searchWatchCompanies');
  const status = useAiChatToolStatus(part.state);

  const hitCount = part.state === 'output-available'
    ? part.output.hits.reduce((sum, seed) => sum + seed.hits.length, 0)
    : 0;

  const summary = part.state === 'output-available'
    ? t('aiChat.tools.watchCompaniesFound', { count: hitCount })
    : status;

  return <AiChatToolCard name={label} status={summary} errorText={part.errorText} />;
}

export default SearchWatchCompaniesToolCall;
